export const WsEvents = {
  lostOrders: {
    GET_DATA: 'LOST_ORDERS:GET_DATA',
    ADD: 'LOST_ORDERS:ADD',
    UPDATE: 'LOST_ORDERS:UPDATE',
    DELETE: 'LOST_ORDERS:DELETE',
    ON_ADDED: 'LOST_ORDERS:ON_ADDED',
    ON_UPDATED: 'LOST_ORDERS:ON_UPDATED',
    ON_DELETED: 'LOST_ORDERS:ON_DELETED',
    JOIN_ROOM: 'LOST_ORDERS:JOIN_ROOM',
    LEAVE_ROOM: 'LOST_ORDERS:LEAVE_ROOM'
  },
  battlefield: {
    GET_DATA: 'BATTLEFIELD:GET_DATA',
    ADD: 'BATTLEFIELD:ADD',
    UPDATE: 'BATTLEFIELD:UPDATE',
    UPDATE_PERIOD: 'BATTLEFIELD:UPDATE_PERIOD',
    DELETE: 'BATTLEFIELD:DELETE',
    ON_ADDED: 'BATTLEFIELD:ON_ADDED',
    ON_UPDATED: 'BATTLEFIELD:ON_UPDATED',
    ON_UPDATED_PERIOD: 'BATTLEFIELD:ON_UPDATED_PERIOD',
    ON_DELETED: 'BATTLEFIELD:ON_DELETED',
    JOIN_ROOM: 'BATTLEFIELD:JOIN_ROOM',
    LEAVE_ROOM: 'BATTLEFIELD:LEAVE_ROOM'
  },
  priority: {
    GET_DATA: 'PRIORITY:GET_DATA',
    ADD: 'PRIORITY:ADD',
    UPDATE: 'PRIORITY:UPDATE',
    DELETE: 'PRIORITY:DELETE',
    ON_ADDED: 'PRIORITY:ON_ADDED',
    ON_UPDATED: 'PRIORITY:ON_UPDATED',
    ON_DELETED: 'PRIORITY:ON_DELETED',
    JOIN_ROOM: 'PRIORITY:JOIN_ROOM',
    LEAVE_ROOM: 'PRIORITY:LEAVE_ROOM'
  },
  transfer: {
    GET_DATA: 'TRANSFER:GET_DATA',
    ON_ADDED: 'TRANSFER:ON_ADDED',
    ON_UPDATED: 'TRANSFER:ON_UPDATED',
    ON_DELETED: 'TRANSFER:ON_DELETED',
    ADD: 'TRANSFER:ADD',
    UPDATE: 'TRANSFER:UPDATE',
    DELETE: 'TRANSFER:DELETE',
    JOIN_ROOM: 'TRANSFER:JOIN_ROOM',
    LEAVE_ROOM: 'TRANSFER:LEAVE_ROOM'
  },
  agent: {
    GET_DATA: 'AGENT:GET_DATA',
    ADD: 'AGENT:ADD',
    UPDATE: 'AGENT:UPDATE',
    DELETE: 'AGENT:DELETE',
    ON_ADDED: 'AGENT:ON_ADDED',
    ON_UPDATED: 'AGENT:ON_UPDATED',
    ON_DELETED: 'AGENT:ON_DELETED',
    JOIN_ROOM: 'AGENT:JOIN_ROOM',
    LEAVE_ROOM: 'AGENT:LEAVE_ROOM'
  },
  leads: {
    GET_DATA: 'LEADS:GET_DATA',
    ADD: 'LEADS:ADD',
    UPDATE: 'LEADS:UPDATE',
    DELETE: 'LEADS:DELETE',
    ON_ADDED: 'LEADS:ON_ADDED',
    ON_UPDATED: 'LEADS:ON_UPDATED',
    ON_DELETED: 'LEADS:ON_DELETED',
    JOIN_ROOM: 'LEADS:JOIN_ROOM',
    LEAVE_ROOM: 'LEADS:LEAVE_ROOM'
  }
};
